module.exports = __webpack_public_path__ + "static/media/logo-white.1998078e.svg";